import { useContext, createContext } from 'react';

export const ToastContext = createContext(null);

export const useToast = () => useContext(ToastContext);
